<template>
    <YoutubeEmbedLite
        :vid="id"
        class="p-about__video-item"
        thumb-quality="hq"
        :params="{start: 0}"
    />
</template>

<script>
import YoutubeEmbedLite from '@miyaoka/vue-youtube-embed-lite'

export default {
    name: 'youtubeVideo',
    components: {YoutubeEmbedLite},
    props: ['id']

}
</script>

<style>
.p-about__video-item .thumb {
    background: url("/assets/img/about/1.png") no-repeat center !important;
    background-size: cover !important;
}

.p-automatize .p-about__video-item .thumb {
    background: url("/assets/img/about/bg-2.png") no-repeat center !important;
    background-size: cover !important;
}
</style>
